
  import { defineComponent } from "vue";
  import { ref } from "vue";
  import axios from "axios";
  import Skeleton from "primevue/skeleton";
  import RouteCard from "../components/RouteCard.vue";
  import Sidebar from "primevue/sidebar";
  import Button from "primevue/button";
  import Ripple from "primevue/ripple";
  import AeroExpress from "../components/AeroExpress.vue";
  import useClipboard from "vue-clipboard3";
  import Toast from "primevue/toast";
  import { useToast } from "primevue/usetoast";
  import OrderModel from "../models/OrderModel";
  import ConfirmDialog from "primevue/confirmdialog";
  import { useRouter, useRoute } from "vue-router";
  import store from "../store";
  import { create } from "yup/lib/Reference";

  const axioCred = axios.create({
    withCredentials: true,
  });

  export default defineComponent({
    name: "Order",
    components: {
      Skeleton,
      RouteCard,
      AeroExpress,
      Sidebar,
      Button,
      Toast,
      ConfirmDialog,
    },
    props: ["order"],
    setup(props) {
      const toast = useToast();
      const router = useRouter();
      const route = useRoute();
      const { toClipboard } = useClipboard();
      let depRoutes: any[] = [];
      let arrRoutes: any[] = [];
      const isLoading = ref(false);
      const cancelLoad = ref(false);
      const error = ref(null);
      const shownOrder = ref<OrderModel | null>(null);
      const numberOfFlights = (elem: any) => {
        for (let el of elem) {
          console.log(el);
          if (el.Direction == 0) {
            depRoutes.push(el);
          } else if (el.Direction == 1) {
            arrRoutes.push(el);
          }
        }
      };
      const showSuccess = () => {
        toast.add({
          severity: "success",
          summary: "Скопировано",
          detail: "в буфер обмена",
          life: 3000,
        });
      };
      const getOrder = async () => {
        isLoading.value = true;
        try {
          const json = await axioCred.get(
            `https://www.biletdv.ru/customer/IBEServices/GetUserOrder?guid=${props.order}&priceData=none&documentsData=none`
          );
          let fetchedOrders = await json.data;
          console.log(fetchedOrders);

          shownOrder.value = fetchedOrders;
          if (
            shownOrder.value !== null &&
            (shownOrder.value.Response || shownOrder.value.error)
          ) {
            isLoading.value = false;
          } else {
            numberOfFlights(fetchedOrders.order.Flights);
            isLoading.value = false;
          }
        } catch (err) {
          if (err.response.status == 401) {
            store.dispatch("auth/logout");
            router.push("/login");
          }
        }
      };
      const copy = async () => {
        try {
          if (shownOrder.value !== null) {
            let copyString: string = JSON.stringify(shownOrder.value.order.Id);
            await toClipboard(copyString);
            showSuccess();
          }
        } catch (e) {
          console.error(e);
        }
      };
      return {
        isLoading,
        error,
        shownOrder,
        getOrder,
        numberOfFlights,
        depRoutes,
        arrRoutes,
        copy,
        showSuccess,
        cancelLoad,
      };
    },
    data() {
      return {
        visibleBottom: false,
        optnInsurOpen: [false, false, false, false, false, false, false, false],
        optnTaxOpen: [false, false, false, false, false, false, false, false],
        optnTicketOpen: [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
        visibleTickets: false,
        visiblePrice: false,
        month: [
          "янв",
          "фев",
          "мар",
          "апр",
          "мая",
          "июн",
          "июл",
          "авг",
          "сен",
          "окт",
          "ноя",
          "дек",
        ],
        hoursWords: ["час", "часа", "часов"],
        minutesWords: ["минута", "минуты", "минут"],
        activeOrder: this.$route.params,
      };
    },
    methods: {
      cancelOrder(guid: any) {
        this.$confirm.require({
          message: "Вы действительно хотите отменить заказ?",
          header: "Подтвердите отмену заказа",
          icon: "pi pi-info-circle",
          acceptClass: "p-button-danger",
          accept: () => {
            this.cancelLoad = true;
            axioCred
              .post(
                `https://www.biletdv.ru/customer/IBEServices/CancelOrder?guid=${guid}`
              )
              .then((res) => {
                if (res.status == 200) {
                  console.log(res);
                  window.location.reload();
                }
              });
          },
          reject: () => {
            //callback to execute when user rejects the action
          },
        });
      },

      isSameDayArr(route: any, aeroexp: any) {
        let toCompareDate1 = new Date(route.ArrivalDate);

        for (let i = 0; i < aeroexp.length; i++) {
          let toCompareDate2 = new Date(aeroexp[i].Time);
          if (
            toCompareDate1.getFullYear() === toCompareDate2.getFullYear() &&
            toCompareDate1.getMonth() === toCompareDate2.getMonth() &&
            toCompareDate1.getDate() === toCompareDate2.getDate()
          ) {
            if (route.Arrival.ArrAirportCodeLat == aeroexp[i].CodeDep) {
              return true;
            } else {
              return false;
            }
          }
        }
      },
      isSameDayDep(route: any, aeroexp: any) {
        let toCompareDate1 = new Date(route.DepartureDate);
        for (let i = 0; i < aeroexp.length; i++) {
          let toCompareDate2 = new Date(aeroexp[i].Time);
          if (
            toCompareDate1.getFullYear() === toCompareDate2.getFullYear() &&
            toCompareDate1.getMonth() === toCompareDate2.getMonth() &&
            toCompareDate1.getDate() === toCompareDate2.getDate()
          ) {
            if (route.Departure.DepAirportCodeLat == aeroexp[i].CodeArr) {
              return true;
            } else {
              return false;
            }
          }
        }
      },
      getAppropriateAeroexp(route: any, aeroexp: any) {
        let toCompareDate1 = new Date(route.DepartureDate);
        for (let i = 0; i < aeroexp.length; i++) {
          let toCompareDate2 = new Date(aeroexp[i].Time);
          if (
            toCompareDate1.getFullYear() === toCompareDate2.getFullYear() &&
            toCompareDate1.getMonth() === toCompareDate2.getMonth() &&
            toCompareDate1.getDate() === toCompareDate2.getDate()
          ) {
            if (route.Departure.DepAirportCodeLat == aeroexp[i].CodeArr) {
              return aeroexp[i];
            } else if (route.Arrival.ArrAirportCodeLat == aeroexp[i].CodeDep) {
              return aeroexp[i];
            }
          }
        }
      },
      getNewPriceDescr(item: any) {
        // let pass = item.Passid;
        // let type = item.ItemType;
        // let total = item.Total;
        let newCalc: any = [{ price: 0, passId: 0 }];
        newCalc[0].passId = item.Passid;
        newCalc[0].price = 0;
        for (let i = 0; i < item.length; i++) {
          for (let j = 0; j < item.length; j++) {
            if (newCalc[i].passId && item[j].Passid == newCalc[i].passId) {
              newCalc[i].price += item[j].Total;
            }
          }
        }
        return newCalc;
      },
      getNewPrice(item: any) {
        let price = 0;
        let id = 0;
        for (let i = 0; i < item.length; i++) {
          if (id == 0) {
            id = item[i].Passid;
            price += item[i].Total;
          } else if (id == item[i].Passid) {
            price += item[i].Total;
          } else {
            return price;
          }
        }
        console.log(price);
        return price;
      },
      getNightHours(date: any) {
        let depDate = new Date(date);
        let hours = depDate.getHours();
        if (hours >= 22 || (hours >= 0 && hours <= 6)) {
          return true;
        } else {
          return false;
        }
      },
      getTimeOfRoute(depDate: any, arrDate: any) {
        let depTime = new Date(depDate);
        let arrTime = new Date(arrDate);
        let diffCount: any = depTime.valueOf() - arrTime.valueOf();
        let finalHours = Math.floor((diffCount % 86400000) / 3600000);
        let finalMinutes = Math.floor(
          ((diffCount % 86400000) % 3600000) / 60000
        );
        return finalHours + "ч " + finalMinutes + "м в пути";
      },
      getHoursTransferTime(depTrans: any, arrTrans: any) {
        let depTime = new Date(depTrans);
        let arrTime = new Date(arrTrans);
        let diffCount: any = depTime.valueOf() - arrTime.valueOf();
        let finalHours = Math.floor((diffCount % 86400000) / 3600000);
        let finalMinutes = Math.round(
          ((diffCount % 86400000) % 3600000) / 60000
        );
        return finalHours + "ч " + finalMinutes + "м";
      },
      declOfHours(number: any, words: any) {
        return words[
          number % 100 > 4 && number % 100 < 20
            ? 2
            : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
        ];
      },
      hide() {
        this.$emit("update:visible", false);
      },
      getWeekDay(date: any) {
        let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
        let weekDay = new Date(date);
        return days[weekDay.getDay()];
      },
      getDate(date: any) {
        let month = [
          "янв",
          "фев",
          "мар",
          "апр",
          "мая",
          "июн",
          "июл",
          "авг",
          "сен",
          "окт",
          "ноя",
          "дек",
        ];
        let monthNum = new Date(date);
        return monthNum.getDate() + " " + month[monthNum.getMonth()];
      },
      getDotDate(date: any) {
        let dotDate;
        let fullDate = new Date(date);
        let day = fullDate.getDate();
        let month = fullDate.getMonth();
        let fullMonth;
        let year = fullDate.getFullYear();
        if (month < 10) {
          fullMonth = "0" + month;
        } else {
          fullMonth = month;
        }
        dotDate = day + "." + fullMonth + "." + year;
        return dotDate;
      },
      getTime(date: any) {
        let time = new Date(date);
        let hours = time.getHours();
        let minutes = time.getMinutes();
        if (minutes < 10) {
          return hours + ":0" + minutes;
        }
        return hours + ":" + minutes;
      },
      getCompanyLogo(company: any) {
        console.log(`("../assets/images/companies/${company}.svg")`);
        return `"@/assets/images/companies/${company}.svg"`;
      },
      getCreatedDate(date: any) {
        function pad(n: any) {
          return n < 10 ? "0" + n : n;
        }
        const now = new Date(date);
        const tz = now.getTimezoneOffset();
        const sign = tz > 0 ? "-" : "+";
        const hours = pad(Math.floor(Math.abs(tz) / 60));
        const minutes = pad(Math.abs(tz) % 60);
        const tzOffset = sign + hours + ":" + minutes;
        const localDateTime =
          now.getFullYear() +
          "-" +
          pad(now.getMonth() + 1) +
          "-" +
          pad(now.getDate()) +
          "T" +
          pad(now.getHours()) +
          ":" +
          pad(now.getMinutes()) +
          ":" +
          pad(now.getSeconds());
        const eventDate = {
          utc: now.toISOString(),
          local: localDateTime,
          tzOffset: tzOffset,
        };

        const localDateString = eventDate.local;
        const localDate = new Date(localDateString);

        let created: any = new Date(localDate);
        if (tz < 0) {
          created.setHours(
            created.getHours() - 10 + Math.floor(Math.abs(tz) / 60)
          );
          created.setMinutes(created.getMinutes() + (Math.abs(tz) % 60));
        } else if (tz > 0) {
          created.setHours(
            created.getHours() - 10 - Math.floor(Math.abs(tz) / 60)
          );
          created.setMinutes(created.getMinutes() - (Math.abs(tz) % 60));
        }

        let createdDay = created.getDate();
        let createdMonth: any = created.getMonth();
        let createdYear = created.getFullYear();
        let createdHours = function () {
          if (created.getHours() < 10) {
            return "0" + created.getHours();
          } else {
            return created.getHours();
          }
        };
        let createdMinutes = function () {
          if (created.getMinutes() < 10) {
            return "0" + created.getMinutes();
          } else {
            return created.getMinutes();
          }
        };

        return (
          createdDay +
          " " +
          this.month[createdMonth] +
          " " +
          createdYear +
          " " +
          createdHours() +
          ":" +
          createdMinutes() +
          " (UTC " +
          tzOffset +
          ")"
        );
      },
      getLimitDate(date: any) {
        function pad(n: any) {
          return n < 10 ? "0" + n : n;
        }
        const now = new Date(date);
        const tz = now.getTimezoneOffset();
        const sign = tz > 0 ? "-" : "+";
        const hours = pad(Math.floor(Math.abs(tz) / 60));
        const minutes = pad(Math.abs(tz) % 60);
        const tzOffset = sign + hours + ":" + minutes;
        const localDateTime =
          now.getFullYear() +
          "-" +
          pad(now.getMonth() + 1) +
          "-" +
          pad(now.getDate()) +
          "T" +
          pad(now.getHours()) +
          ":" +
          pad(now.getMinutes()) +
          ":" +
          pad(now.getSeconds());
        const eventDate = {
          utc: now.toISOString(),
          local: localDateTime,
          tzOffset: tzOffset,
        };

        const localDateString = eventDate.local;
        const localDate = new Date(localDateString);

        let created: any = new Date(localDate);

        if (tz < 0) {
          created.setHours(created.getHours() + Math.floor(Math.abs(tz) / 60));
          created.setMinutes(created.getMinutes() + (Math.abs(tz) % 60));
        } else if (tz > 0) {
          created.setHours(created.getHours() - Math.floor(Math.abs(tz) / 60));
          created.setMinutes(created.getMinutes() - (Math.abs(tz) % 60));
        }

        let createdDay = created.getDate();
        let createdMonth: any = created.getMonth();
        let createdYear = created.getFullYear();
        let createdHours = function () {
          if (created.getHours() < 10) {
            return "0" + created.getHours();
          } else {
            return created.getHours();
          }
        };
        let createdMinutes = function () {
          if (created.getMinutes() < 10) {
            return "0" + created.getMinutes();
          } else {
            return created.getMinutes();
          }
        };

        return (
          createdDay +
          " " +
          this.month[createdMonth] +
          " " +
          createdYear +
          " " +
          createdHours() +
          ":" +
          createdMinutes() +
          " (UTC " +
          tzOffset +
          ")"
        );
      },
      getTimeLimit(date: any) {
        function pad(n: any) {
          return n < 10 ? "0" + n : n;
        }
        const now = new Date(date);
        const tz = now.getTimezoneOffset();
        const sign = tz > 0 ? "-" : "+";
        const hours = pad(Math.floor(Math.abs(tz) / 60));
        const minutes = pad(Math.abs(tz) % 60);
        const tzOffset = sign + hours + ":" + minutes;
        const localDateTime =
          now.getFullYear() +
          "-" +
          pad(now.getMonth() + 1) +
          "-" +
          pad(now.getDate()) +
          "T" +
          pad(now.getHours()) +
          ":" +
          pad(now.getMinutes()) +
          ":" +
          pad(now.getSeconds());
        const eventDate = {
          utc: now.toISOString(),
          local: localDateTime,
          tzOffset: tzOffset,
        };

        const localDateString = eventDate.local;
        const localDate = new Date(localDateString);
        let limit = new Date(localDateTime);
        if (tz < 0) {
          limit.setHours(limit.getHours() + Math.floor(Math.abs(tz) / 60));
          limit.setMinutes(limit.getMinutes() + (Math.abs(tz) % 60));
        } else if (tz > 0) {
          limit.setHours(limit.getHours() - Math.floor(Math.abs(tz) / 60));
          limit.setMinutes(limit.getMinutes() - (Math.abs(tz) % 60));
        }

        let today = new Date();
        if (limit > today) {
          return true;
        } else {
          return false;
        }
      },

      getOrderStatus(num: number) {
        if (num == 40) {
          return "Забронирован";
        } else if (num == 60) {
          return "Оформлен";
        } else if (num == 55 || num == 65) {
          return "Обрабатывается";
        } else if (
          num == 70 ||
          num == 71 ||
          num == 72 ||
          num == 73 ||
          num == 74
        ) {
          return "Отменён";
        }
      },
      getTicketStatus(state: number) {
        if (state == 10) {
          return "Создан";
        } else if (state == 20) {
          return "Выпущен";
        } else if (state == 30) {
          return "Аннулирован";
        } else if (state == 40) {
          return "Возвращен";
        } else if (state == 50) {
          return "Обменян";
        }
      },
      getDateWithDot(date: string) {
        let parseDate = new Date(date);
        let day = parseDate.getDate();
        let month = parseDate.getMonth();
        let year = parseDate.getFullYear();
        return day + " " + this.month[month] + " " + year;
      },
      getTotalPrice(Passengers: any) {
        let totalPrice = 0;
        for (const elem of Passengers) {
          let items = elem.Items;
          for (const el of items) {
            totalPrice += el.Amount;
          }
        }
        return totalPrice;
      },
      getPriceType(items: any) {
        let newArr: any = [{ Description: "Авиабилет", Amount: 0 }];
        for (const elem of items) {
          if (
            elem.ItemType == 1 ||
            elem.ItemType == 202 ||
            elem.ItemType == 335
          ) {
            newArr[0].Amount += elem.Amount;
          } else {
            newArr.push(elem);
          }
        }
        return newArr;
      },
      ticketSave(num: any) {
        window.location.href = `https://bo.biletdv.ru/api/ShowITR/guid/${num}/type/itinerary`;
      },
      insurSave(url: any) {
        window.location.href = url;
      },
      taxSave(num: any) {
        window.location.href = `https://bo.biletdv.ru/api/ShowITR/guid/${num}/type/tax`;
      },
      onClickAwayTicket(index: any) {
        this.optnTicketOpen[index] = false;
      },
      onClickAwayInsur(index: any) {
        this.optnInsurOpen[index] = false;
      },
      onClickAwayTax(index: any) {
        this.optnTaxOpen[index] = false;
      },
      saveCheck(check: any) {
        if (new Date(check.Created) < new Date("2021-07-02")) {
          return `https://check.ofd.ru/rec/2722046551/0001024243050065/9281000100190066/${check.KkmReceiptNumber}/${check.FiscalSign}`;
        } else if (new Date(check.Created) < new Date("2021-08-05")) {
          return `https://check.ofd.ru/rec/2722046551/0002583594045857/9281000100190065/${check.KkmReceiptNumber}/${check.FiscalSign}`;
        } else if (new Date(check.Created) < new Date("2024-08-16")) {
          return `https://check.ofd.ru/rec/2722046551/0002583594045857/9961440300003121/${check.KkmReceiptNumber}/${check.FiscalSign}`;
        } else {
          return `https://check.ofd.ru/rec/2722046551/0002583594045857/7381440800279896/${check.KkmReceiptNumber}/${check.FiscalSign}`;
        }
      },
      getRequesterMail() {
        let mailInfo = sessionStorage.getItem("userName");
        let mail;
        if (mailInfo) {
          mail = JSON.parse(mailInfo);
          return mail;
        } else {
          return "";
        }
      },
      getRouteDataForLink(route: any) {
        let routeData = "";
        for (let i = 0; i < route.length; i++) {
          let date = route[i].DepartureDate;
          let flightNum =
            route[i].OperatingAirline.CodeLat + "-" + route[i].FlightNumber;
          let routeCitys =
            route[i].Departure.City.NameRus +
            "-" +
            route[i].Arrival.City.NameRus;
          let routeString =
            this.getDotDate(date) +
            " " +
            this.getTime(date) +
            " / " +
            flightNum +
            " / " +
            routeCitys +
            "<br>";
          routeData += routeString;
        }
        return routeData;
      },
    },
    created() {
      this.getOrder();
      const unregisterRouterGuard = this.$router.beforeEach(
        (to: any, from: any, next: any) => {
          if (
            this.visibleBottom == true ||
            this.visiblePrice == true ||
            (this.visibleTickets == true &&
              this.optnInsurOpen[0] == false &&
              this.optnInsurOpen[1] == false &&
              this.optnInsurOpen[2] == false &&
              this.optnInsurOpen[3] == false &&
              this.optnInsurOpen[4] == false &&
              this.optnInsurOpen[5] == false &&
              this.optnInsurOpen[6] == false &&
              this.optnInsurOpen[7] == false &&
              this.optnTaxOpen[0] == false &&
              this.optnTaxOpen[1] == false &&
              this.optnTaxOpen[2] == false &&
              this.optnTaxOpen[3] == false &&
              this.optnTaxOpen[4] == false &&
              this.optnTaxOpen[5] == false &&
              this.optnTaxOpen[6] == false &&
              this.optnTaxOpen[7] == false &&
              this.optnTicketOpen[0] == false &&
              this.optnTicketOpen[1] == false &&
              this.optnTicketOpen[2] == false &&
              this.optnTicketOpen[3] == false &&
              this.optnTicketOpen[4] == false &&
              this.optnTicketOpen[5] == false &&
              this.optnTicketOpen[6] == false &&
              this.optnTicketOpen[7] == false)
          ) {
            // event.preventDefault;
            next(false);
            this.visibleBottom = false;
            this.visiblePrice = false;
            this.visibleTickets = false;
            // this.optnInsurOpen[0] = false;
            // this.optnInsurOpen[1] = false;
            // this.optnInsurOpen[2] = false;
            // this.optnInsurOpen[3] = false;
            // this.optnInsurOpen[4] = false;
            // this.optnInsurOpen[5] = false;
            // this.optnInsurOpen[6] = false;
            // this.optnInsurOpen[7] = false;
            // this.optnTaxOpen[0] = false;
            // this.optnTaxOpen[1] = false;
            // this.optnTaxOpen[2] = false;
            // this.optnTaxOpen[3] = false;
            // this.optnTaxOpen[4] = false;
            // this.optnTaxOpen[5] = false;
            // this.optnTaxOpen[6] = false;
            // this.optnTaxOpen[7] = false;
            // this.optnTicketOpen[0] = false;
            // this.optnTicketOpen[1] = false;
            // this.optnTicketOpen[2] = false;
            // this.optnTicketOpen[3] = false;
            // this.optnTicketOpen[4] = false;
            // this.optnTicketOpen[5] = false;
            // this.optnTicketOpen[6] = false;
            // this.optnTicketOpen[7] = false;
            // history.go(1);
          } else if (
            this.optnInsurOpen[0] == true ||
            this.optnInsurOpen[1] == true ||
            this.optnInsurOpen[2] == true ||
            this.optnInsurOpen[3] == true ||
            this.optnInsurOpen[4] == true ||
            this.optnInsurOpen[5] == true ||
            this.optnInsurOpen[6] == true ||
            this.optnInsurOpen[7] == true ||
            this.optnTaxOpen[0] == true ||
            this.optnTaxOpen[1] == true ||
            this.optnTaxOpen[2] == true ||
            this.optnTaxOpen[3] == true ||
            this.optnTaxOpen[4] == true ||
            this.optnTaxOpen[5] == true ||
            this.optnTaxOpen[6] == true ||
            this.optnTaxOpen[7] == true ||
            this.optnTicketOpen[0] == true ||
            this.optnTicketOpen[1] == true ||
            this.optnTicketOpen[2] == true ||
            this.optnTicketOpen[3] == true ||
            this.optnTicketOpen[4] == true ||
            this.optnTicketOpen[5] == true ||
            this.optnTicketOpen[6] == true ||
            this.optnTicketOpen[7] == true
          ) {
            next();
          } else {
            next();
          }
        }
      );
    },
    directives: {
      ripple: Ripple,
    },
  });
